import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import { normalizeRid } from '../../../shared/model/scopeKeys'
import { createDefaultsApi } from '../api/createDefaultsApi'
import type { CreateDefaultsIntentState } from './types'

/**
 * Намерение человека в окне «Создание по умолчанию» по каждой базе: только
 * изменённые поля (ключ → значение, `''` — умолчания нет). Сохранённые
 * значения и справочники — ответ службы в кэше RTK Query (R01). Сохранение
 * прошло — черновик базы больше не нужен: окно показывает сохранённое.
 */
const initialState: CreateDefaultsIntentState = {}

const createDefaultsSlice = createSlice({
  name: 'onec/createDefaults',
  initialState,
  reducers: {
    createDefaultChanged(state, action: PayloadAction<{ resourceId: string; key: string; value: string }>) {
      const rid = normalizeRid(action.payload.resourceId)
      state[rid] = { ...state[rid], [action.payload.key]: action.payload.value }
    },
    createDefaultsReset(state, action: PayloadAction<{ resourceId: string }>) {
      delete state[normalizeRid(action.payload.resourceId)]
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(createDefaultsApi.endpoints.onecCreateDefaultsSave.matchFulfilled, (state, action) => {
      delete state[normalizeRid(action.meta.arg.originalArgs.resourceId)]
    })
  },
})

export const { createDefaultChanged, createDefaultsReset } = createDefaultsSlice.actions
export const createDefaultsReducer = createDefaultsSlice.reducer
